import script from "./CarouselMejoresAgrupaciones.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselMejoresAgrupaciones.vue?vue&type=script&setup=true&lang=js"

import "./CarouselMejoresAgrupaciones.vue?vue&type=style&index=0&id=b9ff057c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9ff057c"]])

export default __exports__